import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerSuccessOptionsAppserviceService } from '../../services/wealthlane-customer-services';

const useGetPublishedRolesFromSource = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string
): UseQueryResult<Array<{ label: string; value: string }> | undefined, unknown> => {
  const companiesOptions = useQuery(
    ['getPublishedRolesFromSource'],
    async () => {
      return await handleRequest(
        CustomerSuccessOptionsAppserviceService.getApiCustomerApiCustomerCustomerSuccessOptionsRolesPublished(
          id
        )
      );
    },
    {
      enabled: !!id,
      select(data) {
        return data?.map((company) => {
          return {
            label: company.name ?? '',
            value: company.id ?? '',
          };
        });
      },
    }
  );
  return companiesOptions;
};

export default useGetPublishedRolesFromSource;
